export default __webpack_public_path__ + "static/media/markdown-previewer-tablet.bbd67907.png";